"use client";

import { useScrollPosition } from "@/lib/hooks/use-scroll-position";
import { cn } from "@/lib/utils";
import type { HeaderThemeType } from "@/types/common.types";

export const TopBar = ({
  children,
  className,
  containerClassName,
  forceSolidSurface = false,
  theme,
}: {
  children: React.ReactNode;
  className?: string;
  containerClassName?: string;
  forceSolidSurface?: boolean;
  theme?: HeaderThemeType;
}) => {
  const scrollPosition = useScrollPosition();
  const isScrolled = scrollPosition > 1;

  return (
    <header
      className={cn(
        "flex w-full items-center justify-center border-transparent border-b bg-transparent transition-all duration-200",
        isScrolled
          ? "bg-white/50 py-2 shadow-md backdrop-blur-lg lg:py-4"
          : "border-white/10 bg-transparent py-2 lg:py-4",
        theme === "all-light" && "border-brand-grey2 bg-white py-2 lg:py-4",
        forceSolidSurface && "bg-white py-2 shadow-none backdrop-blur-none lg:py-4",
        {
          "text-foreground":
            forceSolidSurface ||
            isScrolled ||
            (!isScrolled && ["all-light", "light"].includes(theme ?? "light")),
          "text-white": !isScrolled && theme === "dark-hero",
        },
        className
      )}
    >
      <div className={cn("container flex items-center", containerClassName)}>
        {children}
      </div>
    </header>
  );
};
